import { Fragment } from 'react';
import { Provider } from 'react-redux';

import { store } from './redux/store';
import { PlateBuying } from './views/PlateBuying';
import { Background } from './components/Background';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<PlateBuying />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.PlateBuying)
	.build();

export default Layout;
